// import React, { useEffect, useState } from 'react';
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const Hero = () => {
//     const [startAnim, setStartAnim] = useState(false);

//     useEffect(() => {
//         setTimeout(() => setStartAnim(true), 100);
//     }, []);

//     const settings = {
//         dots: false,
//         arrows: false,
//         infinite: true,
//         speed: 8500,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 0,
//         cssEase: "linear",
//         pauseOnHover: false,
//         responsive: [
//             { breakpoint: 1024, settings: { slidesToShow: 3 } },
//             { breakpoint: 768, settings: { slidesToShow: 2 } },
//             { breakpoint: 500, settings: { slidesToShow: 1 } }
//         ]
//     };

//     const services = [
//         {
//             title: "Mobile Application",
//             // desc: "Comprehensive mobile solutions for enterprise level.", 
//             desc: "We provide comprehensive mobile solutions for a wide range of clients ranging from small startups to enterprise level. We have expertise in providing the power of Mobile Apps for businesses",
//             icon: "https://cdn-icons-png.flaticon.com/512/3437/3437364.png"
//         },
//         {
//             title: "Web Application",
//             //  desc: "Innovative software applications to drive revenue growth.", 
//             desc: "We offer product development services for developing, implementing innovative software applications. We build software products that drive revenue growth for our clients.",
//             icon: "https://cdn-icons-png.flaticon.com/512/1005/1005141.png"
//         },
//         {
//             title: "Machine-integrated Solutions",
//             desc: "Our custom software development service addresses your needs when specific requirements are packaged software. We innovate solutions to satisfy your exact requirements.",
//             icon: "https://cdn-icons-png.flaticon.com/512/2103/2103633.png"
//         },
//         {
//             title: "Product Development",
//             desc: "We offer product development services for developing, implementing innovative software applications. We build software products that drive revenue growth for our clients.",
//             icon: "https://cdn-icons-png.flaticon.com/512/4406/4406323.png"
//         },
//         {
//             title: "Windows Application",
//             desc: "GalaxyERP has experience in delivering high-performance Windows and web applications, even for complex functionalities with a visually rich interface and stringent quality.",
//             icon: "https://cdn-icons-png.flaticon.com/512/906/906309.png"
//         },
//         {
//             title: "Technical Support",
//             desc: "We firmly believe that technical support influences customer buying decisions. Thus, we strive to exceed our clients' expectations by providing excellent product support.",
//             icon: "/assets/img/headphones.png"
//         }
//     ];

//     return (
//         <section className={`section-plm-key-slider dark ${startAnim ? 'start-text-animation' : ''}`}>
//             <div className="hero-container">
//                 <div className="row-intro">
//                     <div className="col">
//                         <h1 className="general-title h1-main">Intelligent Software Solutions</h1>
//                         <h2 className="general-title">Galaxy ERP connects people, systems and processes to optimize performance.</h2>
//                     </div>
//                 </div>

//                 {/* Black Shadow Effect mate Wrapper */}
//                 <div className="carousel-outer-wrapper">
//                     <div className="shadow-overlay left"></div>
//                     <div className="shadow-overlay right"></div>

//                     <div className="carousel-container">
//                         <Slider {...settings}>
//                             {services.map((item, index) => (
//                                 <div className="service-card" key={index}>
//                                     <div className="icon-box">
//                                         <img src={item.icon} alt={item.title} />
//                                     </div>
//                                     <h4 className="service-name">{item.title}</h4>
//                                     <p className="service-text">{item.desc}</p>
//                                 </div>
//                             ))}
//                         </Slider>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Hero;



import React, { useEffect, useRef, useState } from 'react';

const Hero = () => {
    const [startAnim, setStartAnim] = useState(false);
    const trackRef = useRef(null);
    const animationRef = useRef(null);
    const positionRef = useRef(0);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const startPos = useRef(0);
    const lastX = useRef(0);
    const velocity = useRef(0);
    const resumeTimer = useRef(null);
    const cardWidth = 300; // card width + gap

    useEffect(() => {
        setTimeout(() => setStartAnim(true), 100);
    }, []);

    const services = [
        {
            title: "Mobile Application",
            desc: "We provide comprehensive mobile solutions for a wide range of clients ranging from small startups to enterprise level.",
            icon: "https://cdn-icons-png.flaticon.com/512/3437/3437364.png"
        },
        {
            title: "Web Application",
            desc: "We offer product development services for developing innovative software applications that drive revenue growth.",
            icon: "https://cdn-icons-png.flaticon.com/512/1005/1005141.png"
        },
        {
            title: "Machine-integrated Solutions",
            desc: "Our custom software development service addresses your needs with innovative solutions to satisfy exact requirements.",
            icon: "https://cdn-icons-png.flaticon.com/512/2103/2103633.png"
        },
        {
            title: "Product Development",
            desc: "We offer product development services for developing innovative software applications that drive revenue growth.",
            icon: "https://cdn-icons-png.flaticon.com/512/4406/4406323.png"
        },
        {
            title: "Windows Application",
            desc: "GalaxyERP delivers high-performance Windows and web applications with visually rich interface and stringent quality.",
            icon: "https://cdn-icons-png.flaticon.com/512/906/906309.png"
        },
        {
            title: "Technical Support",
            desc: "We strive to exceed our clients' expectations by providing excellent product support that influences buying decisions.",
            icon: "/assets/img/headphones.png"
        }
    ];

    // Duplicate cards for infinite loop
    const allCards = [...services, ...services, ...services];
    const totalWidth = services.length * cardWidth;

    const startAutoScroll = () => {
        if (animationRef.current) return;

        const step = () => {
            if (!isDragging.current) {
                positionRef.current -= 1; // speed: 1px per frame

                // Reset position for infinite loop
                if (Math.abs(positionRef.current) >= totalWidth) {
                    positionRef.current = 0;
                }

                if (trackRef.current) {
                    trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
                }
            }
            animationRef.current = requestAnimationFrame(step);
        };

        animationRef.current = requestAnimationFrame(step);
    };

    const stopAutoScroll = () => {
        if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
            animationRef.current = null;
        }
    };

    useEffect(() => {
        startAutoScroll();
        return () => stopAutoScroll();
    }, []);

    // Touch handlers
    const onTouchStart = (e) => {
        isDragging.current = true;
        startX.current = e.touches[0].clientX;
        lastX.current = e.touches[0].clientX;
        startPos.current = positionRef.current;
        velocity.current = 0;
        if (resumeTimer.current) clearTimeout(resumeTimer.current);
    };

    const onTouchMove = (e) => {
        if (!isDragging.current) return;
        const currentX = e.touches[0].clientX;
        const diff = currentX - startX.current;
        velocity.current = currentX - lastX.current;
        lastX.current = currentX;

        positionRef.current = startPos.current + diff;

        // Boundary check for infinite loop
        if (positionRef.current > 0) positionRef.current = -totalWidth + positionRef.current;
        if (Math.abs(positionRef.current) > totalWidth * 2) positionRef.current = 0;

        if (trackRef.current) {
            trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
        }
    };

    const onTouchEnd = () => {
        isDragging.current = false;

        // Momentum: apply velocity for smooth feel
        let momentum = velocity.current * 8;
        const applyMomentum = () => {
            if (Math.abs(momentum) > 0.5 && !isDragging.current) {
                positionRef.current += momentum;
                momentum *= 0.92;

                if (positionRef.current > 0) positionRef.current = -totalWidth;
                if (Math.abs(positionRef.current) >= totalWidth * 2) positionRef.current = 0;

                if (trackRef.current) {
                    trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
                }
                requestAnimationFrame(applyMomentum);
            } else {
                // Resume auto scroll after 2s
                resumeTimer.current = setTimeout(() => {
                    startAutoScroll();
                }, 1000);
            }
        };

        stopAutoScroll();
        requestAnimationFrame(applyMomentum);
    };

    // Mouse handlers (desktop)
    const onMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.clientX;
        lastX.current = e.clientX;
        startPos.current = positionRef.current;
        velocity.current = 0;
        if (resumeTimer.current) clearTimeout(resumeTimer.current);
        stopAutoScroll();
    };

    const onMouseMove = (e) => {
        if (!isDragging.current) return;
        const diff = e.clientX - startX.current;
        velocity.current = e.clientX - lastX.current;
        lastX.current = e.clientX;
        positionRef.current = startPos.current + diff;

        if (positionRef.current > 0) positionRef.current = -totalWidth;

        if (trackRef.current) {
            trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
        }
    };

    const onMouseUp = () => {
        if (!isDragging.current) return;
        isDragging.current = false;

        resumeTimer.current = setTimeout(() => {
            startAutoScroll();
        }, 1000);
    };

    return (
        <section className={`section-plm-key-slider dark ${startAnim ? 'start-text-animation' : ''}`}>
            <div className="hero-container">
                <div className="row-intro">
                    <div className="col">
                        <h1 className="general-title h1-main">Intelligent Software Solutions</h1>
                        <h2 className="general-title">Galaxy ERP connects people, systems and processes to optimize performance.</h2>
                    </div>
                </div>

                <div className="carousel-outer-wrapper">
                    <div className="shadow-overlay left"></div>
                    <div className="shadow-overlay right"></div>

                    <div
                        className="carousel-container"
                        style={{ overflow: 'hidden', cursor: 'grab', userSelect: 'none' }}
                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={onTouchEnd}
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseUp={onMouseUp}
                        onMouseLeave={onMouseUp}
                    >
                        <div
                            ref={trackRef}
                            style={{
                                display: 'flex',
                                gap: '20px',
                                width: 'max-content',
                                willChange: 'transform'
                            }}
                        >
                            {allCards.map((item, index) => (
                                <div
                                    className="service-card"
                                    key={index}
                                    style={{ width: `${cardWidth - 20}px`, flexShrink: 0 }}
                                >
                                    <div className="icon-box">
                                        <img src={item.icon} alt={item.title} draggable={false} />
                                    </div>
                                    <h4 className="service-name">{item.title}</h4>
                                    <p className="service-text">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;